import { useEffect, useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlatformLogout } from "../../../store/authSlice";
import L from "../../../constants/baysportLabels";
import logo from "../../../assets/logo.svg";
import PlatformAdminLoginPage from "../PlatformAdminLoginPage";
import s from "./platformAdmin.module.css";

const NAV = [
  { to: "/admin", end: true, label: "Сводка", icon: "📊" },
  { to: "/admin/analytics", label: "Аналитика", icon: "📈" },
  { to: "/admin/plans", label: "Тарифы", icon: "💳" },
  { to: "/admin/tenants", label: "Клубы", icon: "🏟️" },
  { to: "/admin/audit", label: "Журнал", icon: "📋" },
];

export default function PlatformAdmin() {
  const dispatch = useDispatch();
  const { isAuth, isPlatformAdmin, profile } = useSelector((state) => state.auth);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isAuth && isPlatformAdmin) {
      import("../../../services/platformApi")
        .then(({ default: platformAPI }) => platformAPI.getAnalytics())
        .then(() => setReady(true))
        .catch(() => setReady(false));
    } else {
      setReady(false);
    }
  }, [isAuth, isPlatformAdmin]);

  if (!isAuth || !isPlatformAdmin) {
    return <PlatformAdminLoginPage />;
  }

  if (!ready) {
    return (
      <div className={s.loginWrap}>
        <div className={s.loginCard}>
          <p style={{ margin: 0 }}>Загрузка админки платформы…</p>
        </div>
      </div>
    );
  }

  return (
    <div className={s.shell}>
      <aside className={s.sidebar}>
        <Link to="/" className={s.brand}>
          <img src={logo} alt="" style={{ height: 28 }} />
          <span>{L.productName}</span>
        </Link>

        <div className={s.adminBadge}>
          <strong>Платформа</strong>
          {profile?.email || "admin"}
        </div>

        <div className={s.navSection}>Управление</div>
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `${s.navLink} ${isActive ? s.navLinkActive : ""}`
            }
          >
            {item.icon} {item.label}
          </NavLink>
        ))}

        <a href="/" className={s.navLink} style={{ marginTop: 8 }}>
          🌐 На сайт
        </a>
        <button
          type="button"
          className={`${s.navLink} ${s.navLogout}`}
          onClick={() => dispatch(fetchPlatformLogout())}
        >
          Выйти
        </button>
      </aside>
      <main className={s.main}>
        <Outlet />
      </main>
    </div>
  );
}
